import { Component, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { Observable, Subscription, combineLatest } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params } from '@angular/router';
import { map, switchMap } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';
import { User } from '../../auth/user';
import { ProductService } from '../product/product.service';
import { ProductEditPopup } from '../product/product-edit-popup/product-edit-popup';
import { ColumnSetting } from '../../layout/table-standard-layout/table-standard-layout.component';
import { ActionButtonEvent } from '../../layout/action-button-toolbar/action-button-toolbar.component';
import { ConfigService } from 'src/app/shared/config';

@Component({
  selector: 'app-special-prices',
  templateUrl: './special-prices.component.html',
  styleUrls: ['./special-prices.component.css']
})
export class SpecialPricesComponent implements OnInit, OnDestroy {
  products$: Observable<{}>;
  siteId: string;
  siteId$: Observable<string>;
  user: User;
  paramsSub: Subscription;
  onEditSubscription: Subscription;

  columnSettings: ColumnSetting[] = [
    {
      columnId: 'name',
      name: 'Name',
    },
      {
      columnId: 'price',
      name: 'Price',
      hideOnMobile: true
    },
    
  ];

  // Action buttons
  onEdit: EventEmitter<ActionButtonEvent>;
  rowActionButtons: { icon: string; tooltip: string; eventEmitter: EventEmitter<ActionButtonEvent>; }[] = [];
  topbarActionButton: { icon: string; tooltip: string; eventEmitter: EventEmitter<ActionButtonEvent>; }[] = [];

  constructor(
    private productService: ProductService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private auth: AuthService,
    private configService: ConfigService
  ) {
    // Initialize event emitters
    this.onEdit = new EventEmitter<ActionButtonEvent>();

    // Subscribe to edit events
    this.onEditSubscription = this.onEdit.subscribe(event => {
      this.editSpecialPrice(event.eventData);
    });

    this.rowActionButtons = [
      { icon: 'edit', tooltip: 'Edit Special Price', eventEmitter: this.onEdit }
    ];

    // No top bar action buttons for now
    this.topbarActionButton = [];
  }

  ngOnInit(): void {
    // Get siteId from route params first
    if (this.route.parent) {
      this.paramsSub = this.route.parent.params.subscribe((params: Params) => {
        if (params['siteId'] != undefined) {
          this.siteId = params['siteId'];
          this.siteId$ = this.route.parent.params.pipe(map(params => params['siteId']));
          
          // Initialize products and load special prices data
          this.productService.getProducts();
          this.loadProductsWithSpecialPrices();
        }
        console.log("Special Prices - siteId: ", this.siteId);
      });
    }

    // Subscribe to user for permissions
    this.auth.user$.subscribe(user => this.user = user);
  }

  // Load products and merge with special prices
  loadProductsWithSpecialPrices(): void {
    if (!this.siteId) {
      console.error('SiteId is not available');
      return;
    }

    // First get products
    this.productService.getProducts();
    
    // Then combine products with special prices
    const products$ = this.productService.data;
    const specialPrices$ = this.productService.getSpecialPrices(
      this.configService.getCompanyId(), 
      this.siteId
    );

    this.products$ = combineLatest([products$, specialPrices$]).pipe(
      map(([products, specialPrices]) => {
        if (!Array.isArray(products)) {
          return [];
        }
        
        console.log('Products:', products.length, 'Special Prices:', specialPrices?.length);
        
        return products.map((product: any) => {
          // Find special price for this product
          const specialPrice = specialPrices?.find(sp => sp.productId === product.id);
          const isSpecial = specialPrice && specialPrice.price !== product.price;
          const result = {
            ...product,
            categories: product.categories ? product.categories.join(', ') : '',
            originalPrice: product.price,
            price: specialPrice ? specialPrice.price : product.price,
            hasSpecialPrice: !!specialPrice,
            specialPriceId: specialPrice?.id,
            rowClass: isSpecial ? 'special-price-row' : ''
          };
          if (isSpecial) {
            console.log('Product with special price:', product.name, 'Special price:', specialPrice.price);
          }
          return result;
        });
      })
    );
  }

  ngOnDestroy(): void {
    if (this.paramsSub) {
      this.paramsSub.unsubscribe();
    }
    if (this.onEditSubscription) {
      this.onEditSubscription.unsubscribe();
    }
  }

  // Open special price edit dialog
  editSpecialPrice(product: any): void {
    const dialogRef = this.dialog.open(ProductEditPopup, {
      disableClose: true,
      width: '750px',
      data: { 
        pId: product.id,
        isSpecialPrice: true,
        siteId: this.siteId
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Special price dialog was closed', result);
      if (result && result.specialPriceSaved) {
        this.loadProductsWithSpecialPrices();
      }
    });
  }
}
